// extracted by mini-css-extract-plugin
export var bodyRow = "_go-d";
export var cardColumns = "_go-e";
export var ellipsesOverflow = "_go-2";
export var flatBottomCorners = "_go-3";
export var flatTopCorners = "_go-4";
export var headerActionsDropdown = "_go-f";
export var headerBottomRow = "_go-c";
export var headerTopRow = "_go-b";
export var orderDetailsWrapper = "_go-0";
export var orderInfoContainer = "_go-1";
export var productDetails = "_go-9";
export var productImage = "_go-5";
export var responsiveTable = "_go-8";
export var shipmentContainer = "_go-a";
export var tableBottomLeft = "_go-6";
export var tableBottomRight = "_go-7";
export var trackingLink = "_go-g";